export enum CardTypeCode {
  Guest = 0,
  Maid = 1,
  Maintenance = 2,
  Management = 3,
  Reception = 4,
  OneTime = 5,
  PassageOnly = 6,
  Housekeeping = 7,
  JoinRoom = 8,
  Adria = 126
}

export class CardType {
    typeId: number;
    code: CardTypeCode;
    name: string;

    constructor() {}

    public static isGuestCard(cardType: CardType) {
      return Number(cardType.code) === CardTypeCode.Guest || Number(cardType.code) === CardTypeCode.JoinRoom
    }

    public static isMaidCard(cardType: CardType) {
      return Number(cardType.code) === CardTypeCode.Maid
    }

    public static isDoorCard(cardType: CardType) {
      return Number(cardType.code) === CardTypeCode.OneTime || // one time
      Number(cardType.code) === CardTypeCode.PassageOnly // passage only
    }

    public static isStaffCard(cardType: CardType) {
      if (!cardType?.code) {
        return false
      }
      return Number(cardType.code) === CardTypeCode.Maid || // room service(maid)
      Number(cardType.code) === CardTypeCode.Maintenance || // Maintenance
      Number(cardType.code) === CardTypeCode.Management ||// Management
      Number(cardType.code) === CardTypeCode.Reception || // reception
      Number(cardType.code) === CardTypeCode.Housekeeping // housekeeping

    }
}
